import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $getSelection, $isRangeSelection, COMMAND_PRIORITY_HIGH } from "lexical";
import { useEffect } from "react";
import { $createStylableButtonNode } from "../nodes/stylable-button-mui";
import { INSERT_STYLABLE_BUTTON_COMMAND, type StylableButtonCommand } from "../types/commands";
import { $insertNode } from "../utils/insert-node";

export function StylableButtonPlugin(): null {
  const [editor] = useLexicalComposerContext();

  useEffect(
    () =>
      editor.registerCommand(
        INSERT_STYLABLE_BUTTON_COMMAND,
        (data: StylableButtonCommand) => {
          const selection = $getSelection();

          if (!$isRangeSelection(selection)) {
            return false;
          }
          const node = $createStylableButtonNode(
            editor._headless,
            data.text,
            data.url,
            data.buttonType,
            data.fullWidth,
            data.format,
          );
          $insertNode(node);

          return true;
        },
        COMMAND_PRIORITY_HIGH,
      ),
    [editor],
  );

  return null;
}
